// extracted by mini-css-extract-plugin
module.exports = {"clientCategoriesStyle":"_3B-o3CokT0MMXGvwej5MO7"};